import React from 'react';

const ProStatusBadgeIcon = props => {
  const { width, height, className, specificLocators } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      data-locator={specificLocators}
      viewBox="0 0 41 20"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFD41E"
          d="M35 10.001c0 4.174 2.13 7.85 5.364 10H10c-5.523 0-10-4.477-10-10s4.477-10 10-10L40.366 0C37.132 2.15 35 5.826 35 10.001z"
          transform="translate(0 -.001)"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M12.308 10.747V13H10.99V6.603h2.496c.48 0 .903.088 1.268.263.365.176.645.426.841.75.197.323.295.692.295 1.105 0 .627-.215 1.121-.644 1.483-.43.362-1.023.543-1.782.543h-1.156zm0-1.068h1.178c.349 0 .615-.082.798-.246.183-.164.274-.399.274-.703 0-.314-.092-.567-.277-.76-.184-.194-.439-.293-.764-.3h-1.209V9.68zm7.656.98h-1.05V13h-1.319V6.603h2.378c.755 0 1.338.168 1.749.505.41.337.615.813.615 1.428 0 .437-.095.8-.284 1.092-.189.292-.475.524-.859.697l1.385 2.615V13h-1.416l-1.2-2.342zm-1.05-1.068h1.063c.331 0 .587-.084.769-.253.182-.168.272-.4.272-.696 0-.302-.085-.54-.257-.712-.171-.173-.434-.26-.788-.26h-1.06v1.921zm10.48.356c0 .63-.11 1.182-.333 1.657-.223.474-.542.84-.956 1.098-.415.258-.89.387-1.426.387-.53 0-1.004-.127-1.42-.382-.416-.255-.738-.62-.966-1.092-.229-.473-.345-1.018-.348-1.633v-.316c0-.63.114-1.185.341-1.664.227-.479.548-.846.962-1.103.415-.256.889-.384 1.422-.384.533 0 1.007.128 1.422.384.414.257.735.624.962 1.103.227.48.34 1.032.34 1.66v.285zm-1.335-.29c0-.67-.12-1.18-.36-1.53-.24-.348-.584-.522-1.029-.522-.442 0-.784.172-1.024.516-.24.344-.362.849-.365 1.514v.312c0 .653.12 1.16.36 1.52.24.36.587.541 1.038.541.442 0 .782-.174 1.02-.52.237-.348.357-.854.36-1.519v-.312z"
          transform="translate(0 -.001)"
        />
      </g>
    </svg>
  );
};

ProStatusBadgeIcon.defaultProps = {
  width: 41,
  height: 20,
};

export default ProStatusBadgeIcon;
